import { render, staticRenderFns } from "./table-header.vue?vue&type=template&id=09006bf4&scoped=true&"
import script from "./table-header.vue?vue&type=script&lang=ts&"
export * from "./table-header.vue?vue&type=script&lang=ts&"
import style0 from "./table-header.vue?vue&type=style&index=0&id=09006bf4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09006bf4",
  null
  
)

export default component.exports